import React from 'react';
import { ArrowRight, FileText } from 'lucide-react';

const FinalCTA = () => {
  return (
    <section id="final-cta" className="section-padding bg-gradient-to-r from-burnt-orange/10 to-olive-brown/10">
      <div className="container-center">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {/* Header */}
          <div className="space-y-6">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-olive-brown">
              Ready to stop losing hours to noise?
            </h2>

            <p className="text-base sm:text-lg md:text-xl text-olive-brown/80 leading-relaxed max-w-3xl mx-auto">
              Let's set up support that makes your week lighter—and your decisions sharper.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-8">
            <a
              href="#contact"
              className="btn-primary group inline-flex items-center justify-center"
              aria-label="Book a Quick Call - 15 minutes. Just clarity."
              title="15 minutes. Just clarity."
            >
              Book a Quick Call
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-300" />
            </a>
            <a
              href="#contact"
              className="btn-secondary group inline-flex items-center justify-center"
              aria-label="Request a Confidential Memo - A written plan for how support fits your role"
              title="A written plan for how support fits your role"
            >
              Request a Confidential Memo
              <FileText className="ml-2 h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
            </a>
          </div>

          {/* Microcopy */}
          <div className="text-center space-y-2 pt-4">
            <p className="text-sm text-olive-brown/60">
              <strong>Primary:</strong> 15 minutes. Just clarity.
            </p>
            <p className="text-sm text-olive-brown/60">
              <strong>Secondary:</strong> A written plan for how support fits your role.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;